module.exports = __webpack_public_path__ + "static/img/login-zhaopin-item.49f3233.png";


//////////////////
// WEBPACK FOOTER
// ./static/login-zhaopin-item.png
// module id = Vt0A
// module chunks = 4